import { inject } from "@angular/core";
import { AuthService } from "./auth.service";
import { CanActivateFn, Router } from "@angular/router";
import { LoggerService } from "../../shared/services/logger.service";

// Role-specific guards for different route groups
export const cmViewGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  // Only ConstructionManager and MarketAdministrator can access CM views
  if (!auth.currentAccount) {
    if (auth.isAuthInteractionInProgress) {
      return false;
    }

    auth.loginRedirect(state.url);
    return false;
  }
  if (!auth.canAccessCMView()) {
    if (auth.isCustomerCareManager() || auth.isAdmin()) {
      logger.infoWithTrace("CCM attempted accessing CM route without CM permissions, Redirecting Construction Manager to CCM view");
      router.navigate(["/ccm"]);
    } else {
      router.navigate(["/unauthorized"]);
    }
    return false;
  }

  return true;
};

export const ccmViewGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);
  if (!auth.currentAccount) {
    if (auth.isAuthInteractionInProgress) {
      return false;
    }

    auth.loginRedirect(state?.url?.slice(1));
    return false;
  }
  // Only CustomerCareManager and MarketAdministrator can access CCM views
  if (!auth.canAccessCCMView()) {
    if (auth.isConstructionManager()) {
      logger.infoWithTrace("CM attempted accessing CCM route without CCM permissions, Redirecting Construction Manager to CM view");
      router.navigate(["/cm"]);
    } else {
      router.navigate(["/unauthorized"]);
    }
    return false;
  }

  return true;
};

export const adminViewGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.currentAccount) {
    if (auth.isAuthInteractionInProgress) {
      return false;
    }

    auth.loginRedirect(state?.url?.slice(1));

    return false;
  }
  if (!auth.isAdmin()) {
    router.navigate(["/unauthorized"]);
    return false;
  }

  return true;
};

export const reportViewGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);

  // Check if user is authenticated
  if (!auth.currentAccount) {
    if (auth.isAuthInteractionInProgress) {
      return false;
    }

    console.log("No account - redirecting to login");
    // Pass the return URL so the user comes back to the report after login
    auth.loginRedirect(state?.url?.slice(1));
    return false;
  }

  return true;
};